<template>
  <level-left class="delete-box">
      <slot></slot>
      <p class="level-item">{{ text }}</p>
      <loader class="level-item" :showLoader="showLoader">{{ loaderText }}</loader>
  </level-left>
</template>

<script>
import LevelLeft from '@/components/LevelLeft.vue';
import Loader from '@/components/Loader.vue';

export default {
  name: 'DeleteBox',
  components: {
    LevelLeft,
    Loader,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    loaderText: {
      type: String,
      required: true,
    },
    showLoader: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>

div.delete-box {
  border: 2px solid $attention;
  background: $attention;
  padding: $content-padding;
}
</style>
